// extracted by mini-css-extract-plugin
module.exports = {"PhotoTitleEditForm__submitBtn":"iv_a bhb_rm","PhotoTitleEditForm__cancelBtn":"iv_b bhb_rq bhb_rp"};